import { GoalSortingMode } from 'shared/types/sorting-mode';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  margin: 0;
  padding: 0;
  width: 100%;

  background: ${({ theme }) => theme.palette.background.default};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => `0 ${theme.spacing(5)} 0 ${theme.spacing(5)}`};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
`;

// Mirrors the goal-list-card's trailing chevron column so the header columns
// line up with the row columns.
export const Spacer = styled.div`
  display: block;
  flex: 0 0 auto;
  width: 3.4rem;
  height: 10px;
`;

export const Item = styled.div<{ $mode: GoalSortingMode }>`
  flex: 0 0 auto;

  ${({ $mode }) => {
    switch ($mode) {
      case GoalSortingMode.Name:
        return css`
          flex: 1;
        `;
      case GoalSortingMode.Progress:
        return css`
          width: 8rem;
        `;
      case GoalSortingMode.Impact:
        return css`
          width: 6.4rem;
          display: none;

          @container goal-list (min-width: 60rem) {
            display: block;
          }
        `;
      case GoalSortingMode.StartDate:
        return css`
          width: 8.8rem;
          display: none;

          @container goal-list (min-width: 80rem) {
            display: block;
          }
        `;
      case GoalSortingMode.Deadline:
        return css`
          width: 8rem;
        `;
      case GoalSortingMode.Tasks:
        return css`
          width: 5.6rem;
          display: none;

          @container goal-list (min-width: 70rem) {
            display: block;
          }
        `;
      case GoalSortingMode.LifeArea:
        return css`
          width: 16.6rem;
          display: none;

          @container goal-list (min-width: 95rem) {
            display: block;
          }
        `;
      default:
        return '';
    }
  }}
`;

export const Button = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  margin: 0;
  padding: ${({ theme }) => `${theme.spacing(1.5)} 0`};
  background: transparent;

  border: none;
  cursor: pointer;
  transition: color 200ms;

  text-align: left;
  color: ${({ theme }) => theme.palette.text.secondary};

  ${({ $active, theme }) =>
    $active &&
    css`
      color: ${theme.palette.text.primary};
    `}

  &:hover {
    ${({ $active }) =>
      !$active &&
      css`
        opacity: 0.8;
      `}
  }
`;

export const DirectionIcon = styled.span<{ $desc: boolean }>`
  display: flex;
  align-items: center;

  font-size: 1.2rem;
  line-height: 62.5%;

  transition: transform 200ms;
  transform: rotate(${({ $desc }) => ($desc ? '180deg' : '0deg')});
`;
